/**
 * Shares List Page
 */
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchShares } from '../sharesSlice';

const SharesList = () => {
  const dispatch = useDispatch();
  const { shares, isLoading } = useSelector((state) => state.shares);

  useEffect(() => {
    dispatch(fetchShares());
  }, [dispatch]);

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-gray-900 dark:text-white">Shares</h1>
        <p className="text-gray-600 dark:text-gray-400">Manage member shares and dividends</p>
      </div>

      {isLoading ? (
        <div className="text-center py-8">Loading...</div>
      ) : (
        <div className="bg-white dark:bg-gray-800 rounded-lg shadow p-6">
          {shares.length > 0 ? (
            <div>Shares data will be displayed here</div>
          ) : (
            <div className="text-center text-gray-500">No shares records found</div>
          )}
        </div>
      )}
    </div>
  );
};

export default SharesList;
